<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="dialog = false">
    <v-card flat>
      <v-card-title>
        Add Recipients
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <member-autocomplete v-model="members"> </member-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-btn :loading="saving" @click="save">
          Add Recipients
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
export default {
  name: "SurveyScheduleDialog",
  components: {
    MemberAutocomplete
  },
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    members: [],
    surveyId: null,
    surveyInstanceId: null
  }),
  computed: {
    ...mapGetters({})
  },
  methods: {
    showDialog(surveyId, surveyInstanceId) {
      this.dialog = true;
      this.members = [];
      this.surveyId = surveyId;
      this.surveyInstanceId = surveyInstanceId;
    },
    save() {
      if (this.$refs.form.validate() && this.members.length > 0) {
        this.saving = true;
        this.$store
          .dispatch("survey/addRecipientsToSurveyInstance", {
            id: this.surveyInstanceId,
            surveyId: this.surveyId,
            recipients: this.members
          })
          .then(() => {
            this.$emit("save");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while adding recipients to a survey."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-input--checkbox {
  margin-top: 0;
}

.v-input--checkbox >>> .v-label {
  font-size: 12px !important;
}

.v-input--checkbox >>> .v-input__control {
  font-size: 100px !important;
}
</style>
